interface Loading {
  kind: 'loading';
}

interface Ready {
  kind: 'ready';
}

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (): Ready => ({
  kind: 'ready',
});

export type State = Loading | Ready;
